// src/auth/authUtils.js

// Base64 URL-safe helpers
export const base64url = (s) =>
  btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');

export const fromBase64url = (s) => {
  const pad = s.length % 4 === 0 ? '' : '='.repeat(4 - (s.length % 4));
  return atob(s.replace(/-/g, '+').replace(/_/g, '/') + pad);
};

// Nonce sencillo
export const nonce = () =>
  crypto.getRandomValues(new Uint32Array(1))[0].toString(16);

// Allow-list de redirects (coma-separado en tu .env)
const ALLOWED = (process.env.REACT_APP_ALLOWED_REDIRECTS || '')
  .split(',')
  .map((s) => s.trim())
  .filter(Boolean);

export const isAllowedRedirect = (url) => {
  try {
    const u = new URL(url);
    return ALLOWED.some((host) => u.origin === new URL(host).origin);
  } catch {
    return false;
  }
};

// Persistencia del state en sesión del navegador
const KEY = 'OAUTH_STATE';

export const saveState = (st) => {
  sessionStorage.setItem(KEY, JSON.stringify(st));
};

export const loadState = () => {
  const raw = sessionStorage.getItem(KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const clearState = () => sessionStorage.removeItem(KEY);